const CheckCircle = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7_889)">
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill="#1A1A1A"
        />
        <path
          d="M15.2737 6.52629C15.6642 6.91682 15.6642 7.54998 15.2737 7.94051L9.44044 13.7738C9.04994 14.1644 8.41674 14.1644 8.02624 13.7738L5.35954 11.1072C4.96902 10.7166 4.96902 10.0835 5.35954 9.693C5.75007 9.3024 6.38323 9.3024 6.77376 9.693L8.73334 11.6525L13.8595 6.52629C14.25 6.13577 14.8832 6.13577 15.2737 6.52629Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7_889">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CheckCircle
